module.exports = __webpack_public_path__ + "static/shop-script-a106aab50e2bb4dac07fa661bb1f4e61.png";